export default __webpack_public_path__ + "static/media/START_LOADING_NEXT_CONTAINER.983c6bca.svg";